/* Mirror the existing renderer; pricing, upload and full-preview controls stay untouched. */
(() => {
  const initialized = new WeakSet();
  function initialize(scope = document) {
    scope.querySelectorAll('.nf-frame-config').forEach((root, index) => {
      if (initialized.has(root)) return;
      const source = root.querySelector('[data-nf-p3d-scene]');
      const card = root.querySelector('.nf-preview-card');
      const bar = root.querySelector('.nf-mobile-bar');
      if (!source || !card || !bar) return;
      initialized.add(root);
      const sectionId = root.closest('[id]')?.id || String(index);
      if (!card.id) card.id = 'nf-frame-preview-' + sectionId;
      const link = document.createElement('a');
      link.className = 'nf-mobile-preview';
      link.href = '#' + card.id;
      link.setAttribute('aria-label', 'Se større forhåndsvisning af din ramme');
      link.title = 'Se større forhåndsvisning';
      bar.prepend(link);
      root.classList.add('has-nf-mini-preview');
      const mobile = window.matchMedia('(max-width: 960px)');
      let scheduled = false;
      function update() {
        scheduled = false;
        if (!root.isConnected || !mobile.matches) return;
        const width = source.clientWidth;
        const height = source.clientHeight;
        if (!width || !height || !link.clientWidth) return;
        const clone = source.cloneNode(true);
        // Copies must never become renderer targets, duplicate IDs or tab stops.
        for (const node of [clone, ...clone.querySelectorAll('*')]) {
          for (const attribute of [...node.attributes]) {
            if (attribute.name === 'id' || attribute.name.startsWith('data-nf-')) node.removeAttribute(attribute.name);
          }
        }
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        const scale = Math.min(link.clientWidth / width, link.clientHeight / height);
        Object.assign(clone.style, {
          position: 'absolute', inset: 'auto', left: '0', top: '0',
          width: width + 'px', height: height + 'px',
          transformOrigin: 'top left', transform: 'scale(' + scale + ')',
          pointerEvents: 'none',
        });
        link.replaceChildren(clone);
      }
      function schedule() {
        if (!scheduled) { scheduled = true; requestAnimationFrame(update); }
      }
      const observer = new MutationObserver(schedule);
      observer.observe(source, { subtree: true, attributes: true, childList: true });
      const resize = new ResizeObserver(schedule);
      resize.observe(source);
      resize.observe(link);
      mobile.addEventListener('change', schedule);
      schedule();
      document.addEventListener('shopify:section:unload', (event) => {
        if (!event.target.contains(root)) return;
        observer.disconnect();
        resize.disconnect();
        mobile.removeEventListener('change', schedule);
      }, { once: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
